import React, {Component} from 'react';
import { createPost } from '../../store/actions/postActions';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

export class CreatePost extends Component {
	state = {
		title: '',
        content: '',
        activated: false
	}
	
	handleChange = (e) => {
		this.setState({
			[e.target.id]: e.target.type === "checkbox" ? e.target.checked : e.target.value // gets the id of element being changed
		})
	}

	handleSubmit = (e) => {
		e.preventDefault();
        this.props.createPost(this.state); // calling the method below
        this.props.history.push("/"); // forward user to the homepage, using the router push method
	}

    render() {
        const { auth } = this.props;
        if(!auth.uid) return <Redirect to='/signin'/> 

        return (
            <div className="container">
                <form onSubmit={this.handleSubmit}>
                    <h5 className="grey-text text-darken-3">Create Post</h5>
                    <div className="input-field">
                        <label htmlFor="title">Title</label>
                        <input
                            type="text"
                            id="title"
                            onChange={this.handleChange} required/>
                    </div>
                    <div className="input-field">
                        <label htmlFor="content">Project Content</label>
                        <textarea
                        className="materialize-textarea"
                            type="text"
                            id="content"
                            onChange={this.handleChange}/>
                    </div>
                    <p>
                        <label>
                            <input type="checkbox" className="filled-in" id="activated" onChange={this.handleChange}/>
                            <span>Activate</span>
                        </label>
                    </p>
                    <div className="input-field">
                        <button className="btn waves-effect waves-light">Create</button>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createPost: (project) => dispatch(createPost(project)) // passing in the project
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePost);